// Pricing figures shown outside the plan table (trial length, starting price, hosting regions). The pricing page and
// the /book-a-demo FAQ both read them from here so they can't drift apart.
import { PLANS } from '~/models/UnifiedInternal';

export const TRIAL_DAYS = 30;

// Paid plans that start with the free trial
export const TRIAL_PLANS = ['Grow', 'Pro'];

// The lowest monthly price of the active paid plans
export const STARTING_PRICE = Math.min(...PLANS.filter((plan) => plan.is_active && (plan.min_price ?? 0) > 0).map((plan) => plan.min_price!));

// Every plan can be hosted in any of these regions
export const HOSTING_REGIONS = ['US', 'EU', 'AU'];
